/* --- Function Index --- */
var site = {
  // 1st function to fire
  ready: ready,
  // 2nd function to fire
  load: load,
  scroll: scroll,
  resize: resize,
  responsive: function getResponsive() {
    var windowWidth = window.innerWidth;
    var size;
    if (windowWidth > 993) {
      size = "lg"
    }
    else if (windowWidth <= 993 && windowWidth > 375) {
      size = "md"
    }
    else if (windowWidth <= 375) {
      size = "sm"
    }

    return size
  }
}

function ready() {  
  scroll();
}

$(document).ready(function () {
  site.ready();
});

function load() {
  $('main').css({
    opacity: 1
  });
}

$(window).on('load', function () {
  site.load();
});

function resize() {
  var r = site.responsive()
}

$(window).on('resize', function () {
  site.resize();
});

// VALIDATE FORMS
(function () {
  'use strict';
  window.addEventListener('load', function () {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }, false);
})();

const Util = {
  getSelectorFromElement(element) {
    var selector = element.getAttribute('data-target')
    if (!selector || selector === '#') {
      selector = element.getAttribute('href') || ''
    }

    try {
      return document.querySelector(selector) ? selector : null
    } catch (err) {
      return null
    }
  },
  getIdFromDropdown(element) {
    var selector = element.parentElement.getAttribute("data-id")

    try {
      return document.getElementById(selector) ? document.getElementById(selector) : null
    } catch (err) {
      return null
    }
  }
}

// Toggle Classes for [data-toggle=] HTML tags.
/* PARAMS: 
  class to toggle: data-toggle="class"
  Target to toggle above class: data-target="header, main"
*/
$(function () {

  $('.menu-op').each(function (index) {
    const delay = (index + 1) * 0.06; // Calculate delay based on index (e.g., 0.1s, 0.2s, etc.)
    $(this).css('transition-delay', `${delay}s`); // Add inline style
  });

  $(document).on('click', '[data-toggle="show"]', function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.currentTarget.tagName === 'A' && $(this).data("prevent") != false) {
      event.preventDefault()
    }

    const $trigger = $(this)
    const selector = Util.getSelectorFromElement(this)
    const selectors = [].slice.call(document.querySelectorAll(selector))
    $(selectors).each(function () {
      const $target = $(this)
      const $data = $trigger.data("toggle")
      $target.toggleClass($data)
      const $focus = $trigger.data("focus")
      if ($focus != "") {
        console.log("focus", $focus)
        $($focus).focus()
      }
    })
  })

  $(document).on('click', '[data-link="offset"]', function (event) {
    event.preventDefault();
    const $offset = $(this).data("link-offset");
    const $trigger = $(this).attr("href");
    if ($($trigger).length) {
      $('html, body').stop().animate({ scrollTop: $($trigger).offset().top - $offset });
    }
  })

  function initBasicCustomCursor2() {
    const cursor2 = document.querySelector(".cursor-2");
  
    if (!cursor2) {
      console.warn("No se encontró .cursor-2 en el DOM");
      return;
    }
  
    let currentX = 0;
    let currentY = 0;
    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let isAnimating = false;
  
    // Ocultar al inicio
    cursor2.style.opacity = "0";
    cursor2.style.transform = `translate(${targetX}px, ${targetY}px)`;
  
    function updateCursor() {
      currentX += (targetX - currentX) * 0.8;
      currentY += (targetY - currentY) * 0.8;
  
      cursor2.style.transform = `translate(${currentX}px, ${currentY}px) `;
  
      if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
        requestAnimationFrame(updateCursor);
      } else {
        isAnimating = false;
      }
    }
  
    function startAnimationLoop() {
      if (!isAnimating) {
        isAnimating = true;
        requestAnimationFrame(updateCursor);
      }
    }
  
    document.addEventListener("pointermove", (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
      currentX = targetX;
      currentY = targetY;
      cursor2.style.transform = `translate(${currentX}px, ${currentY}px) `;
      cursor2.style.opacity = "1";
    }, { once: true });
  
    window.addEventListener("mousemove", (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
      startAnimationLoop();
    });
  
    document.body.addEventListener("mouseleave", () => {
      cursor2.style.opacity = "0";
    });
  
    document.body.addEventListener("mouseenter", () => {
      cursor2.style.opacity = "1";
    });

    document.querySelectorAll("a").forEach((anchor) => {
      anchor.addEventListener("mouseenter", () => {
        cursor2.classList.add("pointer");
      });
    
      anchor.addEventListener("mouseleave", () => {
        cursor2.classList.remove("pointer");
      });
    });

    document.querySelectorAll(".pointsvg").forEach((pointsvg) => {
      pointsvg.addEventListener("mouseenter", () => {
        cursor2.classList.add("pointer");
      });
    
      pointsvg.addEventListener("mouseleave", () => {
        cursor2.classList.remove("pointer");
      });
    });
    
    document.querySelectorAll(".footer-canva").forEach((footerCanva) => {
    footerCanva.addEventListener("mouseenter", () => {
      cursor2.classList.add("pencil");
    });

    footerCanva.addEventListener("mouseleave", () => {
      cursor2.classList.remove("pencil");
  });


}); 
  
  }

  const swiperMenu = new Swiper('#swiper-menu', {
    slidesPerView: 'auto'
  });
  
  initBasicCustomCursor2();

})

let timeClick;

$(document).on('click', function (event) {
  const cursor2 = document.querySelector(".cursor-2");

  if (cursor2) {
    // Check if the clicked element is NOT an anchor, button, or has the class 'pointsvg'
    if (!event.target.matches("a, button, .pointsvg")) {
      if (timeClick) {
        clearTimeout(timeClick);
      }
      cursor2.classList.add("click");
      timeClick = setTimeout(() => {
        cursor2.classList.remove("click");
        timeClick = null;
      }, 200);
    }
  } else {
    console.error("Element '.cursor-2' not found in the DOM.");
  }
});

$(document).ready(function () {
  $(document).on('submit', '#ContactFooter', function (e) {
    console.log("SUBMIT")
    const emailInput = $('.email-contact');
    const errorMessage = $('.text-error-email-contact');
    const email = emailInput.val();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex

    if (!emailRegex.test(email)) {
      e.preventDefault(); 
      errorMessage.show(); 
      emailInput.addClass('submitted'); 
    } else {
      errorMessage.hide(); 
      emailInput.removeClass('submitted'); 
    }
  });
  $(document).on('submit', '#ContactSticker', function (e) {
    const emailInput = $('.contact-sticker');
    const errorMessage = $('.text-error-email-contact-sticker');
    const email = emailInput.val();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
  
    if (!emailRegex.test(email)) {
      e.preventDefault();
      errorMessage.show();
      emailInput.addClass('submitted'); 
    } else {
      errorMessage.hide(); // Hide error message if valid
      emailInput.removeClass('submitted'); // Remove invalid class
    }
  });
});

$(document).on("click", ".input-number-increment", function (e) {
  var quantity = $(this).parent().find("input").val();
  $(this).parent().find("input").val(parseInt(quantity) + 1).change();
});

$(document).on("click", ".input-number-decrement", function (e) {
  var quantity = $(this).parent().find("input").val();
  if (quantity <= 1)
      $(this).parent().find("input").val(1).change();
  else
      $(this).parent().find("input").val(parseInt(quantity) - 1).change();
});

